$shm_hitalama_map_head $mol_view
	map $shm_hitalama_map
		can_change => title_editable
		slideshow_enabled? => slideshow_enabled?
		camera_locked? => camera_locked?
		interaction_locked? => interaction_locked?
		backup_time? => backup_time?
		slideshow_frame? => slideshow_frame?
		slideshow_frame_str => slideshow_frame_str
		viewport_frames_visible? => viewport_frames_visible?
		title? => title?
	team? null
	zoom? 1
	shift? $mol_vector_2d<number> /
		0
		0
	map_cut? null
	history_open? null
	widget_headers_visible? false
	widget_list_visible? false
	file_list_visible? false
	widget_props_visible? false
	editor_mode_enabled? false
	arrows_visible? true
	sub /
		<= Wrapper $mol_view
			sub / <= Wrapper2 $mol_view sub /
				<= Open_in_new $mol_link_iconed
					sub /
						<= Open_in_new_icon $mol_icon_open_in_new
					uri <= open_in_new_uri \
					click? <=> open_in_new_click? null
					- arg *
						section \map
						map <= map_id \
						edit_widget <= edit_widget_arg null
					external true
				<= Title $mol_string_button
					value? <=> title?
					enabled <= title_editable
				<= Settings $mol_pick
					hint \Click to show settings
					trigger_content /
						<= Settings_trigger_icon $mol_icon_dots_vertical
					bubble_content /
						<= Settings_content $shm_hitalama_map_settings
							map <= map
							team? <=> team?
							map_cut <= map_cut null
							zoom? <=> zoom?
							shift? <=> shift?
							history_open? <=> history_open?
		<= Widget_list_visible $mol_check_icon
			hint \Список виджетов
			Icon <= Widget_list_visible_icon $mol_icon_format_list_bulleted
			checked? <=> widget_list_visible? false
		<= Rights_visible $mol_check_icon
			hint \Права доступа
			Icon <= Rights_visible_icon $mol_icon_shield_account
			checked? <=> rights_visible? false
		<= Drawing_tools_visible $mol_check_icon
			hint \Инструменты рисования
			Icon <= Drawing_tools_visible_icon $mol_icon_pencil
			checked? <=> drawing_tools_visible? true
		<= Interaction_locked $mol_check_icon
			hint \Заблокировать карту и расположение виджетов
			Icon <= Interaction_locked_icon $mol_icon_lock
			checked? <=> interaction_locked?
